import { Col, Flex, Row, Space, Typography } from 'antd';
import { ActionButtonLink } from 'components/card/card-action-button-link';
import { Text, Title } from 'components/mvp-typography';
import { PatientInfoContext } from 'features/patient/_utils/patient-info/hook-context-patientinfo';
import { ConcussionComplexityDiagramWrapper } from 'features/patient/patient-summary/components/concussion-complexity-diagram';
import { CriticalAreasCard } from 'features/patient/patient-summary/components/displays/display-critical-areas';
import { DisplayConcussionComplexity } from 'features/patient/patient-summary/components/displays/display-subtype';
import { useCreatePatientUrl } from 'lib/hooks/use-create-patient-url';
import { halfCol } from 'lib/utils/antd';
import { getFirstName } from 'lib/utils/string/normalise';
import { useContext } from 'react';
import { PatientRoutes } from 'routes';

export function ConcussionSummary(props: {
  noTitle?: boolean;
  noViewDetailsButton?: boolean;
}) {
  const { patientInfo } = useContext(PatientInfoContext);
  const createPatientUrl = useCreatePatientUrl();
  const firstName = getFirstName(patientInfo.patient.displayName);
  return (
    <Space
      direction="vertical"
      style={{ /* Fill the column width */ width: '100%' }}
      size={'large'}
    >
      <Space direction="vertical">
        {!props.noTitle && (
          <Typography.Title level={2} style={{ color: '#230056' }}>
            ConcussionRx Summary
          </Typography.Title>
        )}

        <Text>
          Support {firstName} in feeling validated, reassured, and hopeful about
          their recovery by sharing insights from their Concussion Complexity
          Profile. This profile highlights the systems most likely to be
          affected, as well as the typical number of systems involved, offering
          valuable context for estimating recovery timelines and guiding early
          clinical insights.
        </Text>
      </Space>
      <Row>
        <Col {...halfCol}>
          <Flex align={'center'} gap={'large'}>
            <Title level={3} style={{ marginBottom: 0 }}>
              Concussion profile
            </Title>

            <DisplayConcussionComplexity />
          </Flex>

          <CriticalAreasCard />
        </Col>
        <Col {...halfCol}>
          <Flex
            align={'center'}
            justify="center"
            style={{ height: '100%', marginTop: '1rem' }}
          >
            <ConcussionComplexityDiagramWrapper
              concussion={patientInfo.concussion}
            />
          </Flex>
        </Col>
      </Row>
      <Flex align="center">
        <div style={{ flex: 1 }}></div>
      </Flex>
      {!props.noViewDetailsButton && (
        <ActionButtonLink to={createPatientUrl(PatientRoutes.PatientDashboard)}>
          View details
        </ActionButtonLink>
      )}
    </Space>
  );
}
